import { createContext } from "react"

export const LocaleContext = createContext()
export const LocationContext = createContext()
export const BannerContext = createContext()
